export const formErrors = {
	projectId: {
		required: 'Field cannot be empty.',
		pattern: 'Field cannot contain special characters'
	},
	applicationName: {
		required: 'Field cannot be empty.',
		pattern: 'Field cannot contain special characters'
	},
	applicationDomain: {
		required: 'Field cannot be empty.',
		pattern: 'Field cannot contain special characters'
	}
};
export const loginFormErrors = {
	username: {
		required: 'User name cannot be empty.',
		pattern: 'User name cannot contain special characters'
	},
	password: {
		required: 'Password cannot be empty.'
	}
};
export const resetFormErrors = {
	email: {
		required: 'Email cannot be empty.',
		pattern: 'User name cannot contain special characters'
	}
};
export const passwordResetErrors = {
	 oldPassword: {
    required: 'Old Password field cannot be empty.',
	minMax: 'Password length should be between 8 and 20 characters.',
  },
  newPassword: {
    required: 'New Password field cannot be empty.',
    minMax: 'Password length should be between 8 and 20 characters.',
    password: 'Password should contain at least one lowercase letter, one uppercase letter, one digit, and one special character.',
  },
  confirmPassword: {
    required: 'Confirm Password field cannot be empty.',
  },
};

export const contactUsFormErrors = {
	contactNumber:{
		required:'Number cannot be empty.',
		pattern:'Number should be atleast 10-12 digits.'
	},
	name:{
		required:'Name cannot be empty.',
		pattern:'Name should be atleat 5 characters'
	},
	email:{
		required:'email cannot be empty.',
		pattern:'Invaild email'
	},
	productName: {
		required: 'Product Name cannot be empty.',
	},
	categoryName: {
		required: 'Category Name cannot be empty.'
	},
	message: {
		required: 'Message cannot be empty.',
		pattern:'Message should contain atleast 8 characters.'
	},
	attachFile:{
		required:'File size should not exceed 10MB.',
		maxFileSize:'filetype(s) are not supported.'
	}
};
